import React, { useState } from 'react';
import VoiceAgentTab from '../components/testbed/VoiceAgentTab';
import MessagePreviewTab from '../components/testbed/MessagePreviewTab';
import CampaignPreviewTab from '../components/testbed/CampaignPreviewTab';
import BatchTestTab from '../components/testbed/BatchTestTab';
import VoiceAudioTestTab from '../components/testbed/VoiceAudioTestTab';
import PersonasTab from '../components/testbed/PersonasTab';
import HistoryTab from '../components/testbed/HistoryTab';
import TabErrorBoundary from '../components/testbed/TabErrorBoundary';

function TestBed({ practiceId }) {
  const [activeTab, setActiveTab] = useState('batch');

  const tabs = [
    { key: 'batch', label: 'Run Tests (text)' },
    { key: 'audio', label: 'Voice Test (audio)' },
    { key: 'personas', label: 'Personas' },
    { key: 'history', label: 'History' },
    { key: 'voice', label: 'Debug (voice)' },
    { key: 'message', label: 'Message Preview' },
    { key: 'campaign', label: 'Campaign Preview' },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <BeakerIcon />
          <h2 style={styles.title}>TestBed</h2>
        </div>
        <p style={styles.subtitle}>Test features before enabling them live</p>
      </div>

      <div style={styles.tabBar}>
        {tabs.map(tab => (
          <button
            key={tab.key}
            style={{
              ...styles.tab,
              ...(activeTab === tab.key ? styles.tabActive : {})
            }}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div style={styles.content}>
        {activeTab === 'batch' && (
          <TabErrorBoundary tabName="Run Tests"><BatchTestTab practiceId={practiceId} /></TabErrorBoundary>
        )}
        {activeTab === 'audio' && (
          <TabErrorBoundary tabName="Voice Test"><VoiceAudioTestTab practiceId={practiceId} /></TabErrorBoundary>
        )}
        {activeTab === 'personas' && (
          <TabErrorBoundary tabName="Personas"><PersonasTab practiceId={practiceId} /></TabErrorBoundary>
        )}
        {activeTab === 'history' && (
          <TabErrorBoundary tabName="History"><HistoryTab practiceId={practiceId} /></TabErrorBoundary>
        )}
        {activeTab === 'voice' && (
          <VoiceAgentTab practiceId={practiceId} />
        )}
        {activeTab === 'message' && (
          <MessagePreviewTab practiceId={practiceId} />
        )}
        {activeTab === 'campaign' && (
          <CampaignPreviewTab practiceId={practiceId} />
        )}
      </div>
    </div>
  );
}

function BeakerIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 3h6M10 3v6.5L5 19a2 2 0 0 0 1.7 3h10.6a2 2 0 0 0 1.7-3L14 9.5V3" />
      <path d="M8.5 14h7" />
    </svg>
  );
}

const styles = {
  container: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 64px)',
  },
  header: {
    marginBottom: '20px',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#111827',
  },
  title: {
    margin: 0,
    fontSize: '22px',
    fontWeight: 700,
    color: '#111827',
  },
  subtitle: {
    margin: '4px 0 0',
    fontSize: '14px',
    color: '#6b7280',
  },
  tabBar: {
    display: 'flex',
    gap: '0',
    borderBottom: '2px solid #e5e7eb',
    marginBottom: '0',
  },
  tab: {
    padding: '10px 24px',
    fontSize: '14px',
    fontWeight: 500,
    color: '#6b7280',
    background: 'none',
    border: 'none',
    borderBottom: '2px solid transparent',
    marginBottom: '-2px',
    cursor: 'pointer',
    transition: 'color 0.15s, border-color 0.15s',
  },
  tabActive: {
    color: '#3b82f6',
    borderBottomColor: '#3b82f6',
    fontWeight: 600,
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
};

export default TestBed;
